<template>
  <div class="content-page">
    <div class="tab-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>{{ id ? "编辑活动" : "新增活动" }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tab-content" style="padding-top: 15px">
      <el-form ref="goodsForm" :model="goodsForm" :rules="rules" label-width="180px">
        <el-form-item label="活动名称：" prop="activityName">
          <el-input
            v-model="goodsForm.activityName"
            placeholder="请输入活动名称"
            :maxlength="30"
          ></el-input>
        </el-form-item>
        <el-form-item label="活动时间：" prop="time">
          <el-date-picker
            v-model="goodsForm.time"
            @change="timeChange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="expireTimeOption"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="推广页样式：" prop="promotionPageStyle">
          <el-radio-group v-model="goodsForm.promotionPageStyle">
            <el-radio
              v-for="item in promotionPageStyleList"
              :label="item.value"
              :key="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="达人推广说明：" prop="talentPromotionExplain">
          <el-input
            type="textarea"
            placeholder="请输入达人推广说明"
            resize="none"
            v-model="goodsForm.talentPromotionExplain"
            :rows="5"
          ></el-input>
        </el-form-item>
        <el-form-item label="话题开关：">
          <el-switch v-model="goodsForm.isTopic"></el-switch>
        </el-form-item>
        <el-form-item v-if="goodsForm.isTopic" label="话题标题：" prop="itemTopicTitle">
          <el-input
            v-model="goodsForm.itemTopicTitle"
            placeholder="请输入话题标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="定位发布开关：">
          <el-switch v-model="goodsForm.isOpenPoi"></el-switch>
        </el-form-item>
        <el-form-item v-if="goodsForm.isOpenPoi" label="城市关键词:" prop="itemPoiCity">
          <el-input
            v-model="goodsForm.itemPoiCity"
            placeholder="请输入城市关键词"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="goodsForm.isOpenPoi"
          label="地点关键字:"
          prop="itemPoiKeyword"
        >
          <el-input
            v-model="goodsForm.itemPoiKeyword"
            placeholder="请输入地点关键字"
          ></el-input>
        </el-form-item>
        <el-form-item label="开启挂载抖音小程序：">
          <el-switch v-model="goodsForm.isOpenMicroApp"></el-switch>
        </el-form-item>
        <el-form-item
          v-if="goodsForm.isOpenMicroApp"
          label="小程序链接:"
          prop="itemMicroAppSrcUrl"
        >
          <el-input
            v-model="goodsForm.itemMicroAppSrcUrl"
            placeholder="请输入小程序链接"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="goodsForm.isOpenMicroApp"
          label="进入小程序标题:"
          prop="itemMicroAppTitle"
        >
          <el-input
            v-model="goodsForm.itemMicroAppTitle"
            placeholder="请输入进入小程序标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="开启微信小程序跳转：">
          <el-switch
            class="custom"
            v-model="goodsForm.isOpenWxMiniAppPayOpenLink"
          ></el-switch>
        </el-form-item>
        <el-form-item label="开启支付宝小程序跳转：">
          <el-switch
            class="custom"
            v-model="goodsForm.isOpenAlipayMiniAppPayOpenLink"
          ></el-switch>
        </el-form-item>
        <!-- <el-form-item
          label="开启@商家："
          v-if="isOwn || oemInfo.isOpenDyBdmOem || oemInfo.isOpenKsBdmOem"
        >
          <el-switch
            class="custom"
            disabled
            v-model="goodsForm.isOpenAtMe"
            @click.native="openAtMe"
          ></el-switch>
        </el-form-item> -->
        <el-form-item
          label="延迟发布："
          v-if="
            goodsForm.isOpenAtMe &&
            (isOwn || oemInfo.isOpenDyBdmOem || oemInfo.isOpenKsBdmOem)
          "
        >
          <el-input-number
            v-model="goodsForm.delayPublishSecond"
            :min="0"
            label="延迟时间"
            size="small"
          ></el-input-number>
          秒
        </el-form-item>
        <el-form-item
          label="抖音爆店码:"
          v-if="
            goodsForm.dyJsBdmUrl &&
            (isOwn || oemInfo.isOpenDyBdmOem) &&
            $route.path != '/matrixCodeResource/addAndEdit'
          "
        >
          <div class="form-inline-content flex">
            <div class="inside-content center">
              <qrcode
                v-if="goodsForm.dyJsBdmUrl"
                :value="goodsForm.dyJsBdmUrl"
                :options="{ size: 500 }"
                class="scan-code-img"
                id="dyJsBdmUrl"
              ></qrcode>
              <div>
                <el-button type="primary" size="small" @click="downCode('dyJsBdmUrl')"
                  >下载抖音云推码（顾客）</el-button
                >
              </div>
            </div>
            <div class="inside-content center">
              <qrcode
                v-if="goodsForm.dyJsBdmStaffUrl"
                :value="goodsForm.dyJsBdmStaffUrl"
                :options="{ size: 500 }"
                class="scan-code-img"
                id="dyJsBdmStaffUrl"
              ></qrcode>
              <div>
                <el-button
                  type="primary"
                  size="small"
                  @click="downCode('dyJsBdmStaffUrl')"
                  >下载抖音矩阵码（员工）</el-button
                >
              </div>
            </div>
            <div class="inside-content center">
              <qrcode
                v-if="goodsForm.dyJsBdmTalentUrl"
                :value="goodsForm.dyJsBdmTalentUrl"
                :options="{ size: 500 }"
                class="scan-code-img"
                id="dyJsBdmTalentUrl"
              ></qrcode>
              <div>
                <el-button
                  type="primary"
                  size="small"
                  @click="downCode('dyJsBdmTalentUrl')"
                  >下载抖音云客码（达人）</el-button
                >
              </div>
            </div>
            <div class="inside-content center">
              <qrcode
                v-if="goodsForm.dyJsBdmPayFirstUrl"
                :value="goodsForm.dyJsBdmPayFirstUrl"
                :options="{ size: 500 }"
                class="scan-code-img"
                id="dyJsBdmPayFirstUrl"
              ></qrcode>
              <div>
                <el-button
                  type="primary"
                  size="small"
                  @click="downCode('dyJsBdmPayFirstUrl')"
                  >下载抖音云推（顾客先付）</el-button
                >
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item
          label="快手云推码:"
          v-if="
            goodsForm.ksBdmUrl &&
            (isOwn || oemInfo.isOpenKsBdmOem) &&
            $route.path != '/matrixCodeResource/addAndEdit'
          "
        >
          <div class="form-inline-content flex">
            <div class="inside-content center">
              <qrcode
                v-if="goodsForm.ksBdmUrl"
                :value="goodsForm.ksBdmUrl"
                :options="{ size: 500 }"
                class="scan-code-img"
                id="ksBdmUrl"
              ></qrcode>
              <div>
                <el-button type="primary" size="small" @click="downCode('ksBdmUrl')"
                  >下载快手云推码（顾客）</el-button
                >
              </div>
            </div>
            <div class="inside-content center">
              <qrcode
                v-if="goodsForm.ksBdmStaffUrl"
                :value="goodsForm.ksBdmStaffUrl"
                :options="{ size: 500 }"
                class="scan-code-img"
                id="ksBdmStaffUrl"
              ></qrcode>
              <div>
                <el-button type="primary" size="small" @click="downCode('ksBdmStaffUrl')"
                  >下载快手矩阵码（员工）</el-button
                >
              </div>
            </div>
            <div class="inside-content center">
              <qrcode
                v-if="goodsForm.ksBdmTalentUrl"
                :value="goodsForm.ksBdmTalentUrl"
                :options="{ size: 500 }"
                class="scan-code-img"
                id="ksBdmTalentUrl"
              ></qrcode>
              <div>
                <el-button type="primary" size="small" @click="downCode('ksBdmTalentUrl')"
                  >下载快手云客码（达人）</el-button
                >
              </div>
            </div>
            <div class="inside-content center">
              <qrcode
                v-if="goodsForm.ksBdmPayFirstUrl"
                :value="goodsForm.ksBdmPayFirstUrl"
                :options="{ size: 500 }"
                class="scan-code-img"
                id="ksBdmPayFirstUrl"
              ></qrcode>
              <div>
                <el-button
                  type="primary"
                  size="small"
                  @click="downCode('ksBdmPayFirstUrl')"
                  >下载快手云推（顾客先付）</el-button
                >
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="submit()">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="popup"
      :class="{
        show: isShowDyAuthUrl,
      }"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>抖音授权</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="isShowDyAuthUrl = false"
          />
        </div>
        <div class="popup-container">
          <qrcode
            :value="authUrl"
            :options="{ size: 300 }"
            class="scan-code-img"
          ></qrcode>
          <p>请扫一扫二维码进行授权</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  addOrUpdateActivity,
  getSingleActivityList,
  dyShopAuthUrl,
  checkBdmIsAuth,
} from "../api/index";
import qrcode from "@xkeshi/vue-qrcode";
import { mapState } from "vuex";
let authTimer = null;
export default {
  data() {
    return {
      id: "",
      goodsForm: {
        activityName: "",
        time: "",
        startTime: "",
        endTime: "",
        isTopic: false,
        itemTopicTitle: "",
        isOpenPoi: false,
        itemPoiCity: "",
        itemPoiKeyword: "",
        isOpenAtMe: false,
        isOpenWxMiniAppPayOpenLink: true,
        isOpenAlipayMiniAppPayOpenLink: true,
        delayPublishSecond: 0,
        isOpenMicroApp: false,
        itemMicroAppSrcUrl: "",
        itemMicroAppTitle: "",
        promotionPageStyle: 1,
        talentPromotionExplain: "",
        dyJsBdmUrl: "",
        dyJsBdmStaffUrl: "",
        dyJsBdmTalentUrl: "",
        dyJsBdmPayFirstUrl: "",
        ksBdmUrl: "",
        ksBdmStaffUrl: "",
        ksBdmTalentUrl: "",
        ksBdmPayFirstUrl: "",
      },
      rules: {
        talentPromotionExplain: [
          {
            required: true,
            message: "请输入达人推广说明",
            trigger: "blur",
          },
        ],
        activityName: [
          {
            required: true,
            message: "请输入活动标题",
            trigger: "blur",
          },
        ],
        time: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        itemTopicTitle: [
          {
            required: true,
            message: "请输入话题标题",
            trigger: "blur",
          },
        ],
        itemPoiCity: [
          {
            required: true,
            message: "请输入城市关键词",
            trigger: "blur",
          },
        ],
        itemPoiKeyword: [
          {
            required: true,
            message: "请输入地点关键词",
            trigger: "blur",
          },
        ],
        itemMicroAppSrcUrl: [
          {
            required: true,
            message: "请输入小程序链接",
            trigger: "blur",
          },
        ],
        itemMicroAppTitle: [
          {
            required: true,
            message: "请输入进入小程序标题",
            trigger: "blur",
          },
        ],
      },
      expireTimeOption: {
        disabledDate(date) {
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      isShowDyAuthUrl: false,
      authUrl: "",
      promotionPageStyleList: [
        {
          label: "红色",
          value: 1,
        },
        {
          label: "蓝色",
          value: 2,
        },
      ],
    };
  },
  components: {
    qrcode,
  },
  computed: {
    ...mapState({
      isOwn: (state) => state.isOwn,
      oemInfo: (state) => state.oemInfo,
    }),
  },
  watch: {
    isShowDyAuthUrl(val) {
      if (!val) {
        clearInterval(authTimer);
        authTimer = null;
      }
    },
  },
  beforeDestroy() {
    // localStorage.removeItem("updateActivityId");
  },
  mounted() {
    this.id = this.$route.query.activityId;
    console.log(this.id, "id");
    if (this.id) {
      this.getSingleActivityList(this.id);
    }
  },
  methods: {
    getSingleActivityList() {
      getSingleActivityList({
        activityId: this.id,
      }).then((res) => {
        if (res.code == 1) {
          this.goodsForm = {
            activityName: res.data.activityName,
            time: [res.data.startTime, res.data.endTime],
            startTime: res.data.startTime,
            endTime: res.data.endTime,
            isTopic: res.data.isTopic ? true : false,
            itemTopicTitle: res.data.itemTopicTitle,
            isOpenPoi: res.data.isOpenPoi ? true : false,
            itemPoiCity: res.data.itemPoiCity,
            itemPoiKeyword: res.data.itemPoiKeyword,
            isOpenAtMe: res.data.isOpenAtMe ? true : false,
            isOpenWxMiniAppPayOpenLink:
              res.data.isOpenWxMiniAppPayOpenLink == undefined
                ? true
                : res.data.isOpenWxMiniAppPayOpenLink
                ? true
                : false,
            isOpenAlipayMiniAppPayOpenLink:
              res.data.isOpenAlipayMiniAppPayOpenLink == undefined
                ? true
                : res.data.isOpenAlipayMiniAppPayOpenLink
                ? true
                : false,
            delayPublishSecond: res.data.delayPublishSecond || 0,
            isAuth: res.data.isAuth || 0,
            dyJsBdmUrl: res.data.dyJsBdmUrl || "",
            dyJsBdmStaffUrl: res.data.dyJsBdmStaffUrl || "",
            dyJsBdmTalentUrl: res.data.dyJsBdmTalentUrl || "",
            dyJsBdmPayFirstUrl: res.data.dyJsBdmPayFirstUrl || "",
            ksBdmUrl: res.data.ksBdmUrl || "",
            ksBdmStaffUrl: res.data.ksBdmStaffUrl || "",
            ksBdmTalentUrl: res.data.ksBdmTalentUrl || "",
            ksBdmPayFirstUrl: res.data.ksBdmPayFirstUrl || "",
            isOpenMicroApp: res.data.isOpenMicroApp ? true : false,
            itemMicroAppSrcUrl: res.data.itemMicroAppSrcUrl || "",
            itemMicroAppTitle: res.data.itemMicroAppTitle || "",
            promotionPageStyle: res.data.promotionPageStyle || 1,
            talentPromotionExplain: res.data.talentPromotionExplain || "",
          };
        } else {
        }
      });
    },
    timeChange(val) {
      if (val) {
        console.log(val);
        this.goodsForm.startTime = val[0];
        this.goodsForm.endTime = val[1];
      }
    },
    submit(cb = "") {
      // return
      this.$refs.goodsForm.validate((valid) => {
        if (!valid) {
          this.$notify({
            title: "提示",
            message: "请输入相应信息",
            type: "warning",
            duration: 1000,
          });
          return;
        }
      });
      addOrUpdateActivity({
        activityId: this.id,
        activityType: 101,
        activityName: this.goodsForm.activityName,
        startTime: this.goodsForm.startTime,
        endTime: this.goodsForm.endTime,
        isTopic: this.goodsForm.isTopic ? 1 : 0,
        itemTopicTitle: this.goodsForm.itemTopicTitle,
        isOpenPoi: this.goodsForm.isOpenPoi ? 1 : 0,
        itemPoiCity: this.goodsForm.itemPoiCity,
        itemPoiKeyword: this.goodsForm.itemPoiKeyword,
        isOpenAtMe: this.goodsForm.isOpenAtMe ? 1 : 0,
        isOpenWxMiniAppPayOpenLink: this.goodsForm.isOpenWxMiniAppPayOpenLink ? 1 : 0,
        isOpenAlipayMiniAppPayOpenLink: this.goodsForm.isOpenAlipayMiniAppPayOpenLink
          ? 1
          : 0,
        delayPublishSecond: this.goodsForm.delayPublishSecond,
        isOpenMicroApp: this.goodsForm.isOpenMicroApp ? 1 : 0,
        itemMicroAppSrcUrl: this.goodsForm.itemMicroAppSrcUrl,
        itemMicroAppTitle: this.goodsForm.itemMicroAppTitle,
        promotionPageStyle: this.goodsForm.promotionPageStyle,
        talentPromotionExplain: this.goodsForm.talentPromotionExplain,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: `${this.id ? "修改成功" : "新增成功"}`,
            type: "success",
            duration: 1000,
          });
          if (cb) {
            cb(res);
          } else {
            this.$router.push("/marketingActivity");
          }
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "warning",
            duration: 1000,
          });
        }
      });
    },
    openAtMe() {
      if (this.id && this.goodsForm.isAuth) {
        this.goodsForm.isOpenAtMe = !this.goodsForm.isOpenAtMe;
      } else {
        if (!this.id) {
          this.$confirm("活动未保存，是否保存并开启抖音授权？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.submit((res) => {
                this.id = res.data.activityId;
                this.dyShopAuthUrl();
              });
            })
            .catch(() => {});
        } else {
          this.dyShopAuthUrl();
        }
      }
    },
    dyShopAuthUrl() {
      dyShopAuthUrl({
        activityId: this.id,
      }).then((res) => {
        if (res.code == 1) {
          this.authUrl = res.data.authUrl;
          this.isShowDyAuthUrl = true;
          clearInterval(authTimer);
          authTimer = null;
          authTimer = setInterval(() => {
            this.checkBdmIsAuth();
          }, 1000);
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "warning",
            duration: 1000,
          });
        }
      });
    },
    checkBdmIsAuth() {
      checkBdmIsAuth({
        activityId: this.id,
      }).then((res) => {
        if (authTimer && res.data.isAuth) {
          clearInterval(authTimer);
          authTimer = null;
          this.isShowDyAuthUrl = false;
          this.goodsForm.isOpenAtMe = true;
          return;
        }
      });
    },
    downCode(name) {
      let canvas = document.getElementById(name);
      let dataURL = canvas.toDataURL("image/png");
      let a = document.createElement("a"); // 创建一个a节点插入的document
      let event = new MouseEvent("click"); // 模拟鼠标click点击事件
      a.download = `${name}.png`; // 设置a节点的download属性值
      a.href = dataURL; // 将图片的src赋值给a节点的href
      a.dispatchEvent(event);
    },
  },
};
</script>

<style lang="less" scoped>
.popup-container {
  padding: 20px;
  &.center {
    text-align: center;
  }
  p {
    font-size: 18px;
    text-align: center;
    line-height: 25px;
  }
}
.form-inline-content {
  border-bottom: 1px solid #d8d8d8;
  min-height: 40px;
  padding-bottom: 24px;
  &.flex {
    display: flex;
    .inside-content + .inside-content {
      margin-left: 50px;
    }
  }
  .flex-row-start {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
  }
  .inside-content {
    &.center {
      text-align: center;
    }
    .flex-column-around {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      padding-left: 60px;
      box-sizing: border-box;
    }
    .scan-code-img {
      display: inline-block;
      // width: 100px;
      height: 100px;
    }
    .avatar {
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
    .el-input,
    .el-select {
      width: 300px;
      margin-right: 10px;
    }
  }
}
.flex-row-between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.specification-header {
  width: 452px;
  height: 40px;
  background: #f8f8f8;
  padding: 0 10px;
  color: #606266;
  font-size: 12px;
}
.specification-body {
  width: 450px;
  height: auto;
  border: 1px solid #ececec;
  border-top: none;
  padding: 0 10px;
  line-height: 40px;
}
.width25 {
  width: 25%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 10px;
  box-sizing: border-box;
  &:last-child {
    cursor: pointer;
  }
}
.dialog-selproducts {
  .content-page {
    .tab-content {
      padding: 0;
      .products-list {
        width: 100%;
        .list-title {
          display: flex;
          padding: 0 20px 0 0;
          line-height: 40px;
          background: #f8f8f8;
          .title {
            box-sizing: border-box;
            padding-left: 10px;
            flex: 1;
          }
        }
        .list-footer {
          .el-button {
            margin-left: 10px;
          }
        }
      }
    }
  }
}
.dialog-selgoods {
  .content-page {
    overflow: hidden;
    .bd {
      height: 100%;
      &.sort {
        height: 100%;
        overflow-y: scroll;
        .tab-header {
          background: #fffcf5;
          border-bottom-color: #f2e7b8;
        }
        .tab-content {
          .goods-list {
            width: 100%;
          }
        }
      }
    }
    .tab-header {
      .btn-group-one {
        .upload-xls {
          display: inline-block;
          margin: 0 15px;
        }
      }
      .btn-group-two {
        .el-checkbox {
          margin-right: 15px;
        }
      }
    }
    .tab-content {
      padding: 0;
      height: 500px;
      .goods-classify-list {
        width: 120px;
        min-width: 120px;
        height: 100%;
        background: #f8f8f8;
        font-size: 12px;
        overflow: auto;
        li {
          color: #666666;
          padding-left: 20px;
          padding: 15px 20px;
          line-height: 20px;
          border-bottom: 1px solid #eeeeee;
          cursor: pointer;
          width: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &.active {
            background: #fff;
          }
        }
      }
    }
    .tab-footer {
      text-align: center;
      margin: 10px 0;
      .el-button {
        margin-left: 10px;
      }
    }
    .el-pagination {
      padding: 0;
    }
    .goods-list {
      width: calc(100% - 120px);
      min-width: calc(100% - 120px);
      box-sizing: border-box;
      .list-title {
        display: flex;
        padding: 0 20px 0 0;
        line-height: 40px;
        background: #f8f8f8;
        .title {
          box-sizing: border-box;
          padding-left: 10px;
          flex: 1;
          &:first-of-type {
            min-width: 400px;
            max-width: 400px;
            padding-left: 40px;
          }
        }
      }
      .el-checkbox-group {
        height: calc(100% - 96px);
        overflow: auto;
      }
      .search-header {
        line-height: 30px;
        margin: 10px 0;
        font-size: 14px;
        color: #333;
        padding-left: 10px;
        .el-link {
          vertical-align: top;
          line-height: 30px;
          margin-left: 20px;
        }
      }
      &.screen {
        width: 100%;
      }
      .list-footer {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 15px 0 0 10px;
      }
      .goods-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0;
        border-bottom: 1px solid #eeeeee;
        box-sizing: border-box;
      }
      .goods-info {
        display: flex;
        &.active {
          background: #f5f7fa;
        }
        .pic {
          position: relative;
          width: 50px;
          height: 50px;
          border-radius: 4px;
          &::before {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            color: #fff;
            text-align: center;
            line-height: 50px;
            font-size: 12px;
          }
          &.lower-shelf {
            &::before {
              content: "已下架";
            }
          }
          &.sell-out {
            &::before {
              content: "已售罄";
            }
          }
          &.will-sell-out {
            &::before {
              content: "将售罄";
            }
          }
        }
        .info {
          margin-left: 15px;
          .title {
            font-size: 14px;
            line-height: 28px;
            color: #666666;
            .tag-list {
              display: inline-block;
              & > span {
                background: #ee3030;
                color: #fff;
                font-size: 12px;
                border-radius: 3px;
                padding: 0 5px;
              }
            }
          }
          .price {
            font-size: 14px;
            line-height: 22px;
            color: #ee3030;
          }
        }
      }
      .table-action {
        & > span {
          margin: 0 10px;
        }
      }
      .list-none {
        text-align: center;
        font-size: 14px;
        color: #999999;
        padding-top: 200px;
        & > p {
          margin: 10px 0;
        }
      }
    }
  }
}
</style>
